import { render, staticRenderFns } from "./ConfigDocExoplayer.vue?vue&type=template&id=7566cb56&scoped=true&"
import script from "./ConfigDocExoplayer.vue?vue&type=script&lang=js&"
export * from "./ConfigDocExoplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7566cb56",
  null
  
)

export default component.exports